export const assetConfigAudioLiteral = {
  lobbyMusic: {
    path: 'audio/soundtracks/soundtrack_lobby.mp3',
    type: 'music',
    data: {
      volume: 0.15,
      loop: true,
      speed: 1
    }
  },
  matchMusic: {
    path: 'audio/soundtracks/soundtrack_trenchruns.mp3',
    type: 'music',
    data: {
      volume: 0.15,
      loop: true,
      speed: 1
    }
  },
  matchMusicTF: {
    path: 'audio/soundtracks/soundtrack_terraforming.mp3',
    type: 'music',
    data: {
      volume: 0.15,
      loop: true,
      speed: 1
    }
  },

  seedGrow: {
    path: 'audio/tf/seed_grow.mp3',
    type: 'sfx'
  },
  walkOnObsFlat: {
    path: 'audio/tf/walk_on_obs_flat.mp3',
    type: 'sfx'
  },
  walkOnObsRocky: {
    path: 'audio/tf/walk_on_obs_rocky.mp3',
    type: 'sfx'
  },
  walkOnTerraformed: {
    path: 'audio/tf/walk_on_terraformed.mp3',
    type: 'sfx'
  },

  levelCompleted: {
    path: 'audio/level_completed.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },
  loseLife: {
    path: 'audio/sfx/self/SFDS Energy Power 01 Off Small.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },
  bot_reboot: {
    path: 'audio/sfx/self/SFDS Energy Power 01 On Small.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },
  heal: {
    path: 'audio/sfx/self/SFDS Computer Beep Mid 04.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },

  minion_attack: {
    path: 'audio/sfx/enemies/minion_attack.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },
  minion_defeated: {
    path: 'audio/sfx/enemies/minion_defeated.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },

  tower_attack: {
    path: 'audio/sfx/enemies/tower_attack.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },
  tower_destroyed: {
    path: 'audio/sfx/enemies/tower_destroyed.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },

  bot_defeated: {
    path: 'audio/sfx/enemies/zogear_defeated.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },

  skill_positiveFeedback: {
    path: 'audio/sfx/partSkills/SFCK Alarm Low 04.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },
  skill_buryBone: {
    path: 'audio/sfx/partSkills/SFCK Hydraulic 04.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },
  skill_fetchAndSwitch: {
    path: 'audio/sfx/partSkills/NEON HIT SMALL Plasma Bubble Burst.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },
  skill_supersonicBark: {
    path: 'audio/sfx/partSkills/SFCK Energy Wave 02.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },

  skill_counterCower: {
    path: 'audio/sfx/partSkills/countercower.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },
  skill_megaSwat: {
    path: 'audio/sfx/partSkills/NEON WHOOSH LARGE FAST Beam Sabre Movement.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },
  skill_powerPounce: {
    path: 'audio/sfx/partSkills/SFCK Weapons Energy Pulse Large 02.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },
  skill_superHairball: {
    path: 'audio/sfx/partSkills/NEON WHOOSH LARGE FAST Filter Growl.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },

  skill_curlyCork: {
    path: 'audio/sfx/partSkills/curlycork.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },
  skill_roadHog: {
    path: 'audio/sfx/partSkills/NEON BLAST Down With The Sickness.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },
  skill_slobSludge: {
    path: 'audio/sfx/partSkills/NEON HIT LARGE Energy Surge.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },
  skill_vacuumSneeze: {
    path: 'audio/sfx/partSkills/NEON HIT LARGE Thumper Synth.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },
  skill_swatterswing: {
    path: 'audio/sfx/partSkills/swatter_swing.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },
  skill_cavalryCharge: {
    path: 'audio/sfx/partSkills/cavalrycharge.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },
  skill_maneEvent: {
    path: 'audio/sfx/partSkills/mane_event.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },
  skill_buckleUp_main: {
    path: 'audio/sfx/partSkills/buckleup_main.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },
  skill_buckleUp_heal: {
    path: 'audio/sfx/partSkills/buckleup_heal.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },
  skill_buckleUp_damage: {
    path: 'audio/sfx/partSkills/buckleup_damage.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },

  skill_baahBlitz: {
    path: 'audio/sfx/partSkills/baaahblitz_beam.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },
  skill_baahBlitz_debuff: {
    path: 'audio/sfx/partSkills/baaahblitz_debuff.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },
  skill_staticSprint: {
    path: 'audio/sfx/partSkills/staticsprint_heal.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },
  skill_summonFollowers_spawn: {
    path: 'audio/sfx/partSkills/fluffyfollowers_spawn.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },
  puffballFollowers_attack: {
    path: 'audio/sfx/partSkills/fluffyfollowers_attack.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },
  skill_alphaRam_drop: {
    path: 'audio/sfx/partSkills/alpharam_drop.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },
  alphaRam_headbutt: {
    path: 'audio/sfx/partSkills/alpharam_headbutt.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },

  skill_laserBeam: {
    path: 'audio/sfx/coreSkills/laserbeam.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },

  skill_healer_bounceback: {
    path: 'audio/sfx/coreSkills/bounceback.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },
  skill_swapper_triplethreat: {
    path: 'audio/sfx/coreSkills/triplethreat.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },
  skill_pusher_supersoak: {
    path: 'audio/sfx/coreSkills/supersoak.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },
  skill_carry_doubletime: {
    path: 'audio/sfx/coreSkills/doubletime.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },
  skill_tank_selfdefence: {
    path: 'audio/sfx/coreSkills/selfdefense.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },

  skill_dustCloud: {
    path: 'audio/dustCloud.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },
  skill_piercingHowl: {
    path: 'audio/piercingHowl.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },
  skill_tripleCannon: {
    path: 'audio/tripleCanon.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },
  skill_warpDash: {
    path: 'audio/warpDash.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  },

  point_captured: {
    path: 'audio/sfx/enemies/control_point_captured.mp3',
    type: 'sfx',
    data: {
      volume: 0.18
    }
  }
} as const;
